<template>
  <View direction="row" wrap="wrap" gap="sm" v-if="badges?.length">
    <Badge v-for="badge of badges" :key="badge.title" :variant="badge.badgeColor" :label="badge.title" size="small" />
  </View>
</template>

<script setup lang="ts">
import { Badge, View } from '@tallo/design-system';
import { RenterAccessmentBadge } from '@tallo/investor/renter';

defineProps<{
  badges?: RenterAccessmentBadge[];
}>();
</script>
